// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RUBD","label":"styles_label__2Cs5s"};